export const NAMESPACE = "TasksSideBarSpace";

export const SIDEBAR_INSTANCE_ID = "tasks_flyover_instance_id";

export const TAB_IDS = {
  DETAILS: "details",
  MESSAGES: "messages"
};

export const TABS = [
  {
    title: "Details",
    id: TAB_IDS.DETAILS
  },
  {
    title: "Messages",
    id: TAB_IDS.MESSAGES
  }
];

export const TASK_TYPES = {
  FORM: "form",
  FOLLOWUP_FORM: "followup_form",
  DOCUMENT_REQUEST: "document_request",
  INVOICE: "invoice",
  PEOPLE: "people",
  CUSTOM_TASK: "task",
  OPEN_SESSION: "openSession",
  OPEN_SESSION_CONTENT_MODAL: "openSessionContentModal",
  OPEN_APPLICATION: "openApplication",
  ASSIGNED_TASK: "assigned_task",
  TOGGLE_TASK: "toggle_task",
  OPEN_FILE: "open_file",
  GO_TO_PAGE: "go_to_page",
  GO_TO_ALERT: "go_to_alert"
};
